<template>
  <BaseFilterChips :categories="categories" @remove="onRemove($event)" />
</template>
<script>
import BaseFilterChips from "../../base/base-filter/base-filter-chips";
import { defineComponent, computed } from "@vue/composition-api";
import { useSoundkitsFilterContext } from "./soundkits-filter";

export default defineComponent({
  components: { BaseFilterChips },
  setup() {
    const categoryNames = {
      tags: 'Tags',
      types: 'Types',
      instruments: 'Instruments'
    }
    const state = useSoundkitsFilterContext();
    const categories = computed(() => {
      const selected = state.selected;
      const categories = Object.keys(categoryNames)
          .map((key) => ({
            id: key,
            name: categoryNames[key],
            badges: selected[key]
          }))
          .filter(category => category.badges && category.badges.length)

      return categories
    });

    const onRemove = ({ categoryId, badgeId }) => {
      state.selected[categoryId] = state.selected[categoryId].filter((badge) => badge.id !== badgeId);
    }

    return {
      onRemove,
      categories
    }
  },
});
</script>
